import React, { useState, useEffect, useRef, useCallback } from 'react';
import { aNumero, formatearConPuntos } from '../../services/numeros';
import { formatearFechaInput, isoAFechaDisplay, fechaDisplayAIso } from '../../services/fechas';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption, Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions } from '@headlessui/react';
import { ReactComponent as VentasIcon } from '../../assets/icons/VentasIcon.svg';
import { ReactComponent as ClipIcon } from '../../assets/icons/ClipIcon.svg';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import Factura from '../Factura';
import Remito from '../Remito';
import GuiaEnvio from '../GuiaEnvio';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import LoadingSpinner from '../LoadingSpinner';
const VentasForm = () => {
    const formatNumberWithDots = formatearConPuntos;
    const normalizePrice = aNumero;
    const { id } = useParams();
    const isEditing = !!id;
    const [loadingVenta, setLoadingVenta] = useState(!!id);
    const [personeria, setPersoneria] = useState('');
    const [modalidadPago, setModalidadPago] = useState("");
    const [tipoFactura, setTipoFactura] = useState("");
    const [tipoDivisa, setTipoDivisa] = useState("Pesos");
    const [estado, setEstado] = useState("Pendiente");
    const tiposDivisa = ["Pesos", "Dólares", "Reales", "Euros"];
    const modalidadesPago = ["Cheque", "Contado", "Tarjeta de credito", "Tarjeta de débito", "Transferencia"];
    const tiposFactura = ["A", "B", "E", "X"];
    const estadosVenta = ["Pendiente", "Entregado"];
    const [isLoading, setIsLoading] = useState(false);
    const [saveState, setSaveState] = useState('idle');
    const [errorMsg, setErrorMsg] = useState('');
    const [progress, setProgress] = useState(0);
    const [personeriaFilter, setPersoneriaFilter] = useState('');
    const [query, setQuery] = useState('');
    const [productosQueries, setProductosQueries] = useState(['']);
    const [preciosEditables, setPreciosEditables] = useState([{ precio: "" }]);
    const [categoriasSeleccionadas, setCategoriasSeleccionadas] = useState(['']);
    const [enviarPorMail, setEnviarPorMail] = useState(false);
    const [formData, setFormData] = useState({
        fechaDeNacimiento: '', nombre: '', apellido: '', tipo: '', numeroDeDocumento: '',
        razonSocial: '', cuit: '', calle: '', altura: '', piso: '', unidad: '',
        codigoPostal: '', ciudad: '', pais: '', telefono: '', correoElectronico: '',
    });
    const [isFormValid, setIsFormValid] = useState(false);
    // Se prende al primer intento de guardar: hasta entonces no se pinta nada de rojo.
    const [intentoGuardar, setIntentoGuardar] = useState(false);
    const [clientes, setClientes] = useState([]);
    const [selectedCliente, setSelectedCliente] = useState(null);
    const [productos, setProductos] = useState([]);
    const [requiereEnvio, setRequiereEnvio] = useState(false);
    
    const direccionEntregaVacia = { calle: '', altura: '', piso: '', unidad: '', ciudad: '', codigoPostal: '', pais: '', observaciones: '' };
    const [direccionEntregaVenta, setDireccionEntregaVenta] = useState(direccionEntregaVacia);
    
    const handleDireccionEntregaChange = (campo) => (e) => {
        setDireccionEntregaVenta((prev) => ({ ...prev, [campo]: e.target.value }));
    };
    
    const [numeroGuia, setNumeroGuia] = useState('');
    const [fechaDespacho, setFechaDespacho] = useState('');
    const [bultosTotales, setBultosTotales] = useState('');
    const [despachante, setDespachante] = useState('');
    const [costoEnvioEstimado, setCostoEnvioEstimado] = useState('');
    const [archivoEnvio, setArchivoEnvio] = useState(null);
    const [archivoEnvioUrl, setArchivoEnvioUrl] = useState('');
    const archivoEnvioInputRef = useRef(null);
    const [proveedores, setProveedores] = useState([]);
    const [selectedTransportista, setSelectedTransportista] = useState(null);
    const [nuevoTransportista, setNuevoTransportista] = useState({
        razonSocial: '', rubro: 'Transporte', cuit: '', calle: '', altura: '',
        piso: '', unidad: '', codigoPostal: '', ciudad: '', pais: '',
        telefono: '', correoElectronico: '', nombreVendedor: '',
    });
    const [transportistaQuery, setTransportistaQuery] = useState('');
    const navigate = useNavigate();
    
    // ESTADO ACTUALIZADO: Agregamos cantidadNoCobrada y descuento
    const [productosSeleccionados, setProductosSeleccionados] = useState([
        { producto: null, cantidad: "", cantidadNoCobrada: "", esSeña: false, descuento: 0 }
    ]);
    
    const [insumos, setInsumos] = useState({ cajaX6: "" });
    const [cajaId, setCajaId] = useState('');
    const [separadorId, setSeparadorId] = useState('');
    const [cajaDescontada, setCajaDescontada] = useState(false);
    // Lo que la venta tenía guardado al abrirla: sirve para saber cuánto stock
    // ya se descontó y pedir sólo la diferencia cuando se corrigen los insumos.
    const [insumosOriginales, setInsumosOriginales] = useState({ cajaX6: 0, cajaId: '', separadorId: '', cajaDescontada: false });
    
    const normalizeInsumo = (value) => {
        if (!value) return 0;
        return normalizePrice(value);
    };

    // Funciones Base
    const getPrecioUnitario = (index, item) => {
        const precioEditable = preciosEditables[index]?.precio;
        const precioNormalizado = normalizePrice(precioEditable);
        const precioPorDefecto = item.producto?.precioUnidad;
        return precioNormalizado > 0 ? precioNormalizado : precioPorDefecto;
    };

    // EL TRADUCTOR INVISIBLE: Esta función desdobla las líneas para Stock, DB y PDF
    const obtenerProductosProcesados = useCallback(() => {
        const procesados = [];
        productosSeleccionados.forEach((item, index) => {
            if (!item.producto || (!item.cantidad && item.producto.categoria !== 'eventos')) return;

            const isEvento = item.producto.categoria === 'eventos';
            const cantidadTotal = isEvento ? 1 : normalizePrice(item.cantidad);
            const cantidadNoCobrada = isEvento ? 0 : (normalizePrice(item.cantidadNoCobrada) || 0);
            const cantidadCobrada = Math.max(0, cantidadTotal - cantidadNoCobrada);
            const precioUni = getPrecioUnitario(index, item);

            const baseItem = {
                idProducto: item.producto.id,
                nombreProducto: item.producto.nombre,
                categoria: isEvento && item.esSeña ? 'seña' : item.producto.categoria,
                precioUnidad: precioUni,
                tipoUnidad: item.producto?.tipoUnidad,
                vino_id: item.producto.vino_id || null,
            };

            // Línea a cobrar
            if (cantidadCobrada > 0 || (isEvento && cantidadTotal > 0)) {
                procesados.push({
                    ...baseItem,
                    cantidad: isEvento ? 1 : cantidadCobrada,
                    descuento: 0
                });
            }

            // Línea de regalo (Bonificada 100%)
            if (cantidadNoCobrada > 0 && !isEvento) {
                procesados.push({
                    ...baseItem,
                    cantidad: cantidadNoCobrada,
                    descuento: 100
                });
            }
        });
        return procesados;
    }, [productosSeleccionados, preciosEditables]);

    useEffect(() => {
        if (isEditing) return;
        const totalBotellas = calcularTotalBotellas();
        const cajasNecesarias = totalBotellas > 0 ? Math.ceil(totalBotellas / 6) : 0;
        setInsumos(prev => (
            prev.cajaX6 === String(cajasNecesarias || '')
            ? prev
            : { ...prev, cajaX6: cajasNecesarias > 0 ? String(cajasNecesarias) : '' }
        ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productosSeleccionados, isEditing]);

    useEffect(() => {
        const fetchClientes = async () => {
            try {
                const user = getAuth().currentUser;
                if (!user) return;
                const idToken = await user.getIdToken();
                const res = await fetch("https://backend-288175208699.europe-west1.run.app/clientes", {
                    headers: { Authorization: `Bearer ${idToken}` },
                });
                const data = await res.json();
                setClientes(data);
            } catch (err) { console.error("Error cargando clientes:", err); }
        };
        fetchClientes();
    }, []);

    useEffect(() => {
        const fetchProductos = async () => {
            try {
                const user = getAuth().currentUser;
                if (!user) return;
                const idToken = await user.getIdToken();
                const res = await fetch("https://backend-288175208699.europe-west1.run.app/productos", {
                    headers: { Authorization: `Bearer ${idToken}` },
                });
                const data = await res.json();
                setProductos(data);
            } catch (err) { console.error("Error cargando productos:", err); }
        };
        fetchProductos();
    }, []);

    useEffect(() => {
        const fetchProveedores = async () => {
            try {
                const user = getAuth().currentUser;
                if (!user) return;
                const idToken = await user.getIdToken();
                const res = await fetch("https://backend-288175208699.europe-west1.run.app/proveedores", {
                    headers: { Authorization: `Bearer ${idToken}` },
                });
                const data = await res.json();
                setProveedores(data);
            } catch (err) { console.error("Error cargando proveedores:", err); }
        };
        fetchProveedores();
    }, []);

    useEffect(() => {
        if (!isEditing || !nuevoTransportista.razonSocial || selectedTransportista) return;
        const match = proveedores.find(p => (p.razonSocial || '').toLowerCase() === nuevoTransportista.razonSocial.toLowerCase());
        if (match) setSelectedTransportista(match);
    }, [proveedores, isEditing, nuevoTransportista.razonSocial, selectedTransportista]);

    useEffect(() => {
        if (!isEditing || productos.length === 0) return;
        const cargarVenta = async () => {
            try {
                const dbFirestore = getFirestore();
                const snap = await getDoc(doc(dbFirestore, 'ventas', id));
                if (!snap.exists()) {
                    setLoadingVenta(false);
                    return;
                }
                const venta = snap.data();
                if (venta.cliente) {
                    setSelectedCliente(venta.cliente);
                    setPersoneria(venta.cliente.personeria || '');
                    setFormData(prev => ({
                        ...prev,
                        ...venta.cliente,
                        fechaDeNacimiento: isoAFechaDisplay(venta.cliente.fechaDeNacimiento),
                    }));
                }
                setTipoFactura(venta.tipoFactura || '');
                setModalidadPago(venta.modalidadPago || '');
                setTipoDivisa(venta.tipoDivisa || 'Pesos');
                setEstado(venta.estado || 'Pendiente');
                if (venta.datosCheque) {
                    setDatosCheque({
                        ...venta.datosCheque,
                        fechaVencimiento: isoAFechaDisplay(venta.datosCheque.fechaVencimiento),
                    });
                }
                if (venta.comprobanteTransferenciaUrl) setComprobanteTransferenciaUrl(venta.comprobanteTransferenciaUrl);
                setRequiereEnvio(!!venta.requiere_envio);
                setDireccionEntregaVenta({ ...direccionEntregaVacia, ...(venta.direccionEntrega || {}) });
                
                if (venta.datosEnvio) {
                    setNumeroGuia(venta.datosEnvio.numeroGuia || '');
                    setFechaDespacho(isoAFechaDisplay(venta.datosEnvio.fechaDespacho));
                    setCostoEnvioEstimado(venta.datosEnvio.costoEstimado ? formatNumberWithDots(String(venta.datosEnvio.costoEstimado)) : '');
                    setBultosTotales(venta.datosEnvio.bultosTotales ? String(venta.datosEnvio.bultosTotales) : '');
                    setDespachante(venta.datosEnvio.despachante || '');
                    setArchivoEnvioUrl(venta.datosEnvio.archivoUrl || '');
                    if (venta.datosEnvio.empresaTransporte) {
                        setNuevoTransportista(prev => ({ ...prev, razonSocial: venta.datosEnvio.empresaTransporte }));
                    }
                }
                if (venta.insumos) {
                    setInsumos({ cajaX6: venta.insumos.cajaX6 ? String(venta.insumos.cajaX6) : '' });
                    setCajaId(venta.insumos.cajaId || '');
                    setSeparadorId(venta.insumos.separadorId || '');
                    setCajaDescontada(!!venta.insumos.cajaDescontada);
                    setInsumosOriginales({
                        cajaX6: Number(venta.insumos.cajaX6) || 0,
                        cajaId: venta.insumos.cajaId || '',
                        separadorId: venta.insumos.separadorId || '',
                        cajaDescontada: !!venta.insumos.cajaDescontada,
                    });
                }
                const lineas = venta.productosVendidos || [];
                if (lineas.length > 0) {
                    setProductosSeleccionados(lineas.map(linea => ({
                        producto: productos.find(p => p.id === linea.idProducto) || {
                            id: linea.idProducto,
                            nombre: linea.nombreProducto,
                            categoria: linea.categoria,
                            vino_id: linea.vino_id,
                            precioUnidad: linea.precioUnidad,
                            tipoUnidad: linea.tipoUnidad
                        },
                        cantidad: String(linea.cantidad ?? ''),
                        cantidadNoCobrada: "", // Al editar ya viene desdoblado
                        descuento: linea.descuento || 0,
                        esSeña: linea.categoria === 'seña',
                    })));
                    setPreciosEditables(lineas.map(linea => ({
                        precio: linea.precioUnidad != null ? String(linea.precioUnidad) : '',
                    })));
                    setProductosQueries(lineas.map(() => ''));
                    setCategoriasSeleccionadas(lineas.map(linea => linea.categoria || ''));
                }
            } catch (error) {
                console.error('Error al cargar la venta a editar:', error);
            } finally {
                setLoadingVenta(false);
            }
        };
        cargarVenta();
    }, [isEditing, id, productos]);

    const handleClienteSelect = (cliente) => {
        if (cliente) {
            setSelectedCliente(cliente);
            setPersoneria(cliente.personeria);
            setFormData(prev => ({ ...prev, ...cliente, fechaDeNacimiento: isoAFechaDisplay(cliente.fechaDeNacimiento) }));
            if (!isEditing) {
                setDireccionEntregaVenta({
                    calle: cliente.calle || '', altura: cliente.altura || '', piso: cliente.piso || '', unidad: cliente.unidad || '',
                    ciudad: cliente.ciudad || '', codigoPostal: cliente.codigoPostal || '', pais: cliente.pais || '',
                });
            }
        } else {
            setSelectedCliente(null);
            setPersoneria('');
            if (!isEditing) setDireccionEntregaVenta(direccionEntregaVacia);
            setFormData({
                fechaDeNacimiento: '', nombre: '', apellido: '', tipo: '', numeroDeDocumento: '', razonSocial: '', cuit: '',
                calle: '', altura: '', piso: '', unidad: '', codigoPostal: '', ciudad: '', pais: '', telefono: '', correoElectronico: '',
            });
        }
    };

    const handlePersoneriaChange = (value) => {
        setPersoneria(value);
        if (value === 'persona fisica') {
            setFormData(prevData => ({ ...prevData, razonSocial: '', cuit: '' }));
        } else {
            setFormData(prevData => ({ ...prevData, nombre: '', apellido: '', tipo: '', numeroDeDocumento: '' }));
        }
    };

    // El input de búsqueda de los combobox vive dentro de un Combobox.Button, y
    // Headless UI usa la barra espaciadora del botón para abrir/seleccionar la
    // opción activa. Sin cortar la propagación el espacio nunca llega al texto
    // que se está tipeando, así que no se puede buscar "malbec reserva".
    const permitirEspacioEnBusqueda = (event) => {
        if (event.key === ' ') event.stopPropagation();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let formattedValue = value;
        if (name === 'fechaDeNacimiento') formattedValue = formatearFechaInput(value);
        else if (name === 'numeroDeDocumento') {
            const digitsOnly = value.replace(/\D/g, '');
            if (formData.tipo === 'DNI') {
                if (!digitsOnly) formattedValue = '';
                else if (digitsOnly.length <= 2) formattedValue = digitsOnly;
                else if (digitsOnly.length <= 5) formattedValue = `${digitsOnly.substring(0, digitsOnly.length - 3)}.${digitsOnly.substring(digitsOnly.length - 3)}`;
                else formattedValue = `${digitsOnly.substring(0, digitsOnly.length - 6)}.${digitsOnly.substring(digitsOnly.length - 6, digitsOnly.length - 3)}.${digitsOnly.substring(digitsOnly.length - 3)}`;
            } else if (formData.tipo === 'CUIT/CUIL') {
                if (digitsOnly.length <= 2) formattedValue = digitsOnly;
                else if (digitsOnly.length <= 10) formattedValue = `${digitsOnly.substring(0, 2)}-${digitsOnly.substring(2, digitsOnly.length - 1)}-${digitsOnly.substring(digitsOnly.length - 1)}`;
                else formattedValue = `${digitsOnly.substring(0, 2)}-${digitsOnly.substring(2, 10)}-${digitsOnly.substring(10, 11)}`;
            }
        } else if (name === 'cuit') {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 2) formattedValue = digitsOnly;
            else if (digitsOnly.length <= 10) formattedValue = `${digitsOnly.substring(0, 2)}-${digitsOnly.substring(2, digitsOnly.length - 1)}-${digitsOnly.substring(digitsOnly.length - 1)}`;
            else formattedValue = `${digitsOnly.substring(0, 2)}-${digitsOnly.substring(2, 10)}-${digitsOnly.substring(10, 11)}`;
        }
        setFormData({ ...formData, [name]: formattedValue });
    };

    const facturaOriginalRef = useRef();
    const facturaDuplicadoRef = useRef();
    const facturaTriplicadoRef = useRef();
    const remitoRef = useRef();
    const [mostrarFactura, setMostrarFactura] = useState(false);
    const [numeroFactura, setNumeroFactura] = useState('');

    const tieneSeña = () => productosSeleccionados.some(item => item.producto?.categoria === 'eventos' && item.esSeña);
    const tieneEvento = () => productosSeleccionados.some(item => item.producto?.categoria === 'eventos');

    useEffect(() => {
        if (tieneSeña()) setTipoFactura('R');
        else if (tipoFactura === 'R') setTipoFactura(''); 
    }, [productosSeleccionados]);

// Captura una hoja del documento a imagen. Es la parte cara: html2canvas
// rasteriza el DOM en el main thread, así que cada llamada congela la pestaña
// por segundos. De ahí que capturemos cada hoja UNA sola vez.
const capturarHoja = async (ref) => {
    const input = ref.current;
    if (!input) return null;
    const canvas = await html2canvas(input, { scale: 1.5, useCORS: true });
    return canvas.toDataURL('image/jpeg', 0.75);
};

// Arma un PDF a partir de imágenes ya capturadas (no vuelve a tocar el DOM).
const pdfDesdeImagenes = (imagenes) => {
    const pdf = new jsPDF('p', 'mm', 'a4');
    let primera = true;
    imagenes.forEach((imgData) => {
        if (!imgData) return;
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        if (!primera) pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
        primera = false;
    });
    return pdf.output('blob');
};

// Genera los dos PDFs de la venta con una sola pasada de capturas:
//   - interno: 3 hojas de factura + remito (si aplica)
//   - cliente: las mismas 3 hojas de factura, sin remito
// Las 3 hojas de factura son idénticas en los dos documentos, así que se
// capturan una vez y se reusan. Antes se capturaban dos veces (7 rasterizados
// en total en vez de 4) y eso era casi todo el tiempo de espera al guardar.
const generarPDFsDeVenta = async () => {
    const imagenesFactura = [];
    for (const ref of [facturaOriginalRef, facturaDuplicadoRef, facturaTriplicadoRef]) {
        imagenesFactura.push(await capturarHoja(ref));
    }

    const imagenRemito = (!tieneSeña() && remitoRef.current) ? await capturarHoja(remitoRef) : null;

    return {
        interno: pdfDesdeImagenes([...imagenesFactura, imagenRemito]),
        cliente: pdfDesdeImagenes(imagenesFactura),
    };
};

useEffect(() => {
    if (mostrarFactura && numeroFactura) {
        const generarYSubirPDFs = async () => {
            try {
                const storage = getStorage();

                // 1. Una sola pasada de capturas para los dos documentos.
                const { interno, cliente } = await generarPDFsDeVenta();

                // 2. Las dos subidas van en paralelo: son independientes y
                //    esperar una para arrancar la otra era tiempo regalado.
                const [, urlCliente] = await Promise.all([
                    interno
                        ? uploadBytes(storageRef(storage, `facturas/${numeroFactura}.pdf`), interno)
                        : Promise.resolve(null),
                    cliente
                        ? uploadBytes(storageRef(storage, `facturas_cliente/${numeroFactura}.pdf`), cliente)
                              .then((res) => getDownloadURL(res.ref))
                        : Promise.resolve(''),
                ]);

                // 3. El mail se dispara y no se espera: el vendedor no tiene
                //    nada que hacer con la respuesta, y si falla se loguea
                //    igual. Esperarlo sólo lo dejaba mirando el spinner.
                if (enviarPorMail && urlCliente) {
                    (async () => {
                        try {
                            const user = getAuth().currentUser;
                            if (!user) return;
                            const idToken = await user.getIdToken();
                            await fetch("https://backend-288175208699.europe-west1.run.app/api/send-receipt-email", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${idToken}`
                                },
                                body: JSON.stringify({
                                    venta_id: numeroFactura,
                                    pdf_url: urlCliente
                                }),
                            });
                        } catch (err) {
                            console.error("Error al intentar enviar el mail:", err);
                        }
                    })();
                }
            } catch (error) {
                console.error("Error procesando los PDFs de la venta:", error);
            } finally {
                setMostrarFactura(false);
                setIsLoading(false);
                setProgress(100);
                navigate("/ventas");
            }
        };

        generarYSubirPDFs();
    }
}, [mostrarFactura, numeroFactura, productosSeleccionados, navigate, enviarPorMail, selectedCliente, formData, personeria]);

    const empresaTransporteActual = () => selectedTransportista ? selectedTransportista.razonSocial : nuevoTransportista.razonSocial;
    
    const motivoNoImprimirGuiaForm = () => {
        if (!selectedCliente && !formData.nombre && !formData.razonSocial) return "Falta cargar los datos del cliente.";
        if (!direccionEntregaVenta.calle) return "Falta el domicilio de entrega.";
        if (!empresaTransporteActual()) return "Falta cargar la empresa de transporte.";
        if (!(Number(bultosTotales) > 0)) return "Falta cargar la cantidad de bultos totales.";
        if (!despachante) return "Falta cargar el despachante.";
        return null;
    };

    const [imprimiendoGuiaForm, setImprimiendoGuiaForm] = useState(false);
    const guiaFormRefs = useRef([]);
    const ventanaGuiaFormRef = useRef(null);
    
    const handleImprimirGuiaForm = () => {
        ventanaGuiaFormRef.current = window.open('', '_blank');
        guiaFormRefs.current = [];
        setImprimiendoGuiaForm(true);
    };

    useEffect(() => {
        if (!imprimiendoGuiaForm) return;
        const generar = async () => {
            try {
                const PAGE_WIDTH_MM = 210;
                const PAGE_HEIGHT_MM = 148.5;
                const cantidadBultos = Number(bultosTotales) || 1;
                const pdf = new jsPDF('l', 'mm', [PAGE_HEIGHT_MM, PAGE_WIDTH_MM]);
                for (let i = 0; i < cantidadBultos; i++) {
                    const input = guiaFormRefs.current[i];
                    if (!input) continue;
                    const canvas = await html2canvas(input, { scale: 2, useCORS: true });
                    const imgData = canvas.toDataURL('image/png');
                    if (i > 0) pdf.addPage([PAGE_HEIGHT_MM, PAGE_WIDTH_MM], 'l');
                    pdf.addImage(imgData, 'PNG', 0, 0, PAGE_WIDTH_MM, PAGE_HEIGHT_MM);
                }
                const blobUrl = pdf.output('bloburl');
                const ventana = ventanaGuiaFormRef.current;
                if (ventana && !ventana.closed) ventana.location.href = blobUrl;
                else window.open(blobUrl, '_blank');
            } catch (error) {
                console.error("Error al generar la guía de envío:", error);
                alert("No se pudo generar la guía de envío.");
            } finally { setImprimiendoGuiaForm(false); }
        };
        generar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imprimiendoGuiaForm]);

    const [datosCheque, setDatosCheque] = useState({ numeroCheque: '', bancoEmisor: '', fechaVencimiento: '' });
    
    const handleChequeChange = (e) => {
        const { name, value } = e.target;
        setDatosCheque(prev => ({ ...prev, [name]: name === 'fechaVencimiento' ? formatearFechaInput(value) : value }));
    };

    const [comprobanteTransferencia, setComprobanteTransferencia] = useState(null);
    const [comprobanteTransferenciaUrl, setComprobanteTransferenciaUrl] = useState('');
    const comprobanteInputRef = useRef(null);
    
    const handleComprobanteFileChange = (e) => { if (e.target.files[0]) setComprobanteTransferencia(e.target.files[0]); };
    const handleComprobanteButtonClick = () => comprobanteInputRef.current.click();
    
    const handleModalidadPagoChange = (value) => {
        setModalidadPago(value);
        if (value !== 'Cheque') setDatosCheque({ numeroCheque: '', bancoEmisor: '', fechaVencimiento: '' });
        if (value !== 'Transferencia') { setComprobanteTransferencia(null); setComprobanteTransferenciaUrl(''); }
    };

    const subirComprobanteTransferencia = async (numeroVenta, idToken) => {
        if (!comprobanteTransferencia || !numeroVenta) return;
        try {
            const storage = getStorage();
            const extension = comprobanteTransferencia.name.split('.').pop();
            const fileRef = storageRef(storage, `comprobantes_transferencia/${numeroVenta}.${extension}`);
            await uploadBytes(fileRef, comprobanteTransferencia);
            const url = await getDownloadURL(fileRef);
            await fetch(`https://backend-288175208699.europe-west1.run.app/editar-venta/${numeroVenta}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
                body: JSON.stringify({ comprobanteTransferenciaUrl: url }),
            });
            setComprobanteTransferenciaUrl(url);
        } catch (error) { console.error('Error al subir el comprobante de transferencia:', error); }
    };

    const handleArchivoEnvioFileChange = (e) => { if (e.target.files[0]) setArchivoEnvio(e.target.files[0]); };
    const handleArchivoEnvioButtonClick = () => archivoEnvioInputRef.current.click();
    const handleNuevoTransportistaChange = (e) => setNuevoTransportista(prev => ({ ...prev, [e.target.name]: e.target.value }));
    
    const handleTransportistaCuitChange = (e) => {
        const digits = e.target.value.replace(/\D/g, '');
        let formatted = digits;
        if (digits.length > 2 && digits.length <= 10) formatted = `${digits.slice(0, 2)}-${digits.slice(2)}`;
        else if (digits.length > 10) formatted = `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10, 11)}`;
        setNuevoTransportista(prev => ({ ...prev, cuit: formatted }));
    };

    const construirDatosEnvio = (archivoUrlOverride) => ({
        numeroGuia: numeroGuia || '',
        empresaTransporte: selectedTransportista ? selectedTransportista.razonSocial : nuevoTransportista.razonSocial,
        cuitTransportista: selectedTransportista ? (selectedTransportista.cuit || '') : (nuevoTransportista.cuit || ''),
        fechaDespacho: fechaDisplayAIso(fechaDespacho) || '',
        costoEstimado: normalizePrice(costoEnvioEstimado) || 0,
        bultosTotales: Number(bultosTotales) || 0,
        despachante: despachante || '',
        archivoUrl: archivoUrlOverride !== undefined ? archivoUrlOverride : archivoEnvioUrl,
    });

    const subirArchivoEnvio = async (numeroVenta, idToken) => {
        if (!archivoEnvio || !numeroVenta) return;
        try {
            const storage = getStorage();
            const extension = archivoEnvio.name.split('.').pop();
            const fileRef = storageRef(storage, `guias_envio/${numeroVenta}.${extension}`);
            await uploadBytes(fileRef, archivoEnvio);
            const url = await getDownloadURL(fileRef);
            await fetch(`https://backend-288175208699.europe-west1.run.app/editar-venta/${numeroVenta}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
                body: JSON.stringify({ datosEnvio: construirDatosEnvio(url) }),
            });
            setArchivoEnvioUrl(url);
        } catch (error) { console.error('Error al subir el archivo de envío:', error); }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIntentoGuardar(true);
        const faltantes = calcularCamposFaltantes();
        if (faltantes.size > 0) {
            setSaveState('error');
            setErrorMsg('Faltan completar los campos marcados en rojo.');
            return;
        }
        setIsLoading(true);
        setSaveState('idle');
        setErrorMsg('');
        setProgress(0);
        
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) { setIsLoading(false); alert("Debés iniciar sesión para registrar una venta."); return; }

        if (estado === 'Entregado' && faltanCajasX6) { setIsLoading(false); alert(`No hay suficiente stock de '${cajaElegida?.nombre || cajaId}': hacen falta ${cajasX6Faltantes} y quedan ${cajaX6Disponible}.`); return; }
        if (estado === 'Entregado' && faltanSeparadores) { setIsLoading(false); alert(`No hay suficiente stock de '${separadorElegido?.nombre || separadorId}': hacen falta ${separadoresFaltantes} y quedan ${separadorDisponible}.`); return; }

        let fechaNacimientoIso = '';
        if (!selectedCliente && formData.fechaDeNacimiento) {
            fechaNacimientoIso = fechaDisplayAIso(formData.fechaDeNacimiento);
            if (!fechaNacimientoIso) {
                setIsLoading(false); setSaveState('error'); setErrorMsg('Fecha de nacimiento no es una fecha válida. Usá el formato dd/mm/aaaa.'); return;
            }
        }
        
        let datosChequeAEnviar = datosCheque;
        if (modalidadPago === 'Cheque' && datosCheque.fechaVencimiento) {
            const fechaVencimientoIso = fechaDisplayAIso(datosCheque.fechaVencimiento);
            if (!fechaVencimientoIso) {
                setIsLoading(false); setSaveState('error'); setErrorMsg('Fecha de vencimiento del cheque no es una fecha válida. Usá el formato dd/mm/aaaa.'); return;
            }
            datosChequeAEnviar = { ...datosCheque, fechaVencimiento: fechaVencimientoIso };
        }
        
        if (requiereEnvio && fechaDespacho && !fechaDisplayAIso(fechaDespacho)) {
            setIsLoading(false); setSaveState('error'); setErrorMsg('Fecha de despacho no es una fecha válida. Usá el formato dd/mm/aaaa.'); return;
        }
        
        const idToken = await user.getIdToken();
        let creador = "";
        try {
            const db = getFirestore();
            const userSnap = await getDoc(doc(db, "usuarios", user.uid));
            if (userSnap.exists()) creador = `${userSnap.data().nombre} ${userSnap.data().apellido}`;
            else creador = "Usuario desconocido";
        } catch (error) { creador = "Usuario desconocido"; }

        const totalNeto = calcularTotalNeto();
        let iva = 0;
        let totalConImpuestos = 0;
        if (['A', 'B', 'E'].includes(tipoFactura)) {
            iva = calcularIvaDiferenciado();
            totalConImpuestos = totalNeto + iva;
        } else {
            totalConImpuestos = totalNeto;
        }
        const finalAmountToSend = tieneSeña() ? calcularTotalCompletoConImpuestos() / 2 : totalConImpuestos;

        // Utilizamos obtenerProductosProcesados() para mandar las líneas ya divididas al backend
        const productosVendidosFinal = obtenerProductosProcesados().map(item => ({
            idProducto: item.idProducto,
            nombreProducto: item.nombreProducto,
            categoria: item.categoria,
            cantidad: item.cantidad,
            precioUnidad: item.precioUnidad,
            descuento: item.descuento,
            vino_id: item.vino_id
        }));

        const ventaData = {
            cliente: selectedCliente ? { id: selectedCliente.id, ...selectedCliente } : {
                ...formData,
                ...(requiereEnvio ? direccionEntregaVenta : {}),
                fechaDeNacimiento: fechaNacimientoIso,
                personeria: personeria,
            },
            productosVendidos: productosVendidosFinal,
            insumos: { cajaX6: normalizeInsumo(insumos.cajaX6), cajaId: cajaId || null, separadorId: separadorId || null },
            tipoFactura: tipoFactura,
            modalidadPago: modalidadPago,
            tipoDivisa: tipoDivisa,
            estado: estado,
            totalNeto: totalNeto,
            iva: iva,
            totalFinal: finalAmountToSend,
            ...(!isEditing && { fechaVenta: new Date().getTime() }),
            creador: creador,
            datosCheque: modalidadPago === 'Cheque' ? datosChequeAEnviar : undefined,
            requiere_envio: requiereEnvio,
            datosEnvio: requiereEnvio ? construirDatosEnvio() : undefined,
            direccionEntrega: requiereEnvio ? direccionEntregaVenta : undefined,
            ...(requiereEnvio && !selectedTransportista && nuevoTransportista.razonSocial && { nuevoProveedorTransporte: nuevoTransportista }),
            ...(tieneSeña() && { tipoVenta: 'RESERVA' }),
            ...(!tieneSeña() && tieneEvento() && { tipoVenta: 'EVENTO' }),
        };

        try {
            const url = isEditing
                ? `https://backend-288175208699.europe-west1.run.app/editar-venta/${id}`
                : "https://backend-288175208699.europe-west1.run.app/ventas";
            
            const response = await fetch(url, {
                method: isEditing ? 'PUT' : 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
                body: JSON.stringify(ventaData),
            });
            if (!response.ok) throw new Error(`Error en la respuesta del servidor: ${response.statusText}`);
            
            const result = await response.json();
            if (isEditing) {
                await subirComprobanteTransferencia(id, idToken);
                await subirArchivoEnvio(id, idToken);
                setProgress(100); setSaveState('saved');
                setTimeout(() => navigate('/ventas'), 800);
                return;
            }
            const numeroFacturaDelBackend = result.numeroFactura;
            await subirComprobanteTransferencia(numeroFacturaDelBackend, idToken);
            await subirArchivoEnvio(numeroFacturaDelBackend, idToken);
            setNumeroFactura(numeroFacturaDelBackend);
            setMostrarFactura(true);
            setProgress(100);
            setSaveState('saved');
        } catch (error) {
            console.error('Error al enviar la venta:', error);
            setSaveState('error'); setErrorMsg(error.message || 'Error al enviar la venta.');
            setIsLoading(false); setProgress(0);
        }
    };

    useEffect(() => {
        if (isEditing) { setIsFormValid(personeria !== ''); return; }
        let isValid = false;
        const tieneContacto = (formData.correoElectronico || '').trim() !== '' || (formData.telefono || '').trim() !== '';
        if (personeria === 'persona fisica') {
            isValid = ['nombre', 'apellido', 'tipo', 'numeroDeDocumento'].every(field => (formData[field] || '').trim() !== '') && tieneContacto;
        } else if (personeria === 'persona juridica') {
            isValid = ['razonSocial', 'cuit'].every(field => (formData[field] || '').trim() !== '') && tieneContacto;
        }
        setIsFormValid(isValid);
    }, [formData, personeria, isEditing]);

    // Qué campos obligatorios están vacíos ahora mismo. Es una función pura sobre
    // el estado actual, así que el borde rojo se apaga solo en cuanto se completa
    // el campo: no hace falta reintentar el guardado para limpiarlo.
    const calcularCamposFaltantes = () => {
        const faltan = new Set();
        const vacio = (valor) => (valor || '').toString().trim() === '';

        if (!personeria) faltan.add('personeria');

        if (!selectedCliente) {
            if (personeria === 'persona fisica') {
                ['nombre', 'apellido', 'tipo', 'numeroDeDocumento'].forEach((c) => { if (vacio(formData[c])) faltan.add(c); });
            } else if (personeria === 'persona juridica') {
                ['razonSocial', 'cuit'].forEach((c) => { if (vacio(formData[c])) faltan.add(c); });
            }
            // Alcanza con teléfono o mail; si no hay ninguno se marcan los dos.
            if (vacio(formData.telefono) && vacio(formData.correoElectronico)) {
                faltan.add('telefono');
                faltan.add('correoElectronico');
            }
        }

        // Al editar los productos son de sólo lectura (el fieldset está disabled).
        if (!isEditing) {
            if (!productosSeleccionados.some((item) => item.producto)) faltan.add('producto-0');
            productosSeleccionados.forEach((item, index) => {
                if (!item.producto || item.producto.categoria === 'eventos') return;
                if (!(normalizePrice(item.cantidad) > 0)) faltan.add(`cantidad-${index}`);
            });
            if (!tipoFactura) faltan.add('tipoFactura');
        }

        if (!modalidadPago) faltan.add('modalidadPago');
        if (modalidadPago === 'Cheque') {
            ['numeroCheque', 'bancoEmisor', 'fechaVencimiento'].forEach((c) => {
                if (vacio(datosCheque[c])) faltan.add(`cheque-${c}`);
            });
        }

        if (requiereEnvio) {
            if (vacio(direccionEntregaVenta.calle)) faltan.add('envio-calle');
            if (vacio(direccionEntregaVenta.ciudad)) faltan.add('envio-ciudad');
            if (vacio(empresaTransporteActual())) faltan.add('envio-transportista');
        }

        return faltan;
    };

    const camposFaltantes = intentoGuardar ? calcularCamposFaltantes() : new Set();
    const marcarFaltante = (clave) => (camposFaltantes.has(clave) ? ' campo-faltante' : '');

    const personeriaOptions = [{ value: 'persona fisica', label: 'Persona física' }, { value: 'persona juridica', label: 'Persona jurídica' }];
    const tipoDocumentoOptions = [{ value: 'DNI', label: 'DNI' }, { value: 'Pasaporte', label: 'Pasaporte' }, { value: 'Libreta Cívica', label: 'Libreta Cívica' }, { value: 'CUIT/CUIL', label: 'CUIT/CUIL' }];
    
    const filteredClientes = clientes.filter((cliente) => {
        const personeriaMatch = personeriaFilter === '' || cliente.personeria === personeriaFilter;
        if (!personeriaMatch) return false;
        if (query === '') return true;
        const nombreCompleto = cliente.personeria === "persona fisica" ? `${cliente.nombre} ${cliente.apellido}`.toLowerCase() : cliente.razonSocial.toLowerCase();
        return `${nombreCompleto} ${cliente.numeroDeDocumento || ''} ${cliente.cuit || ''}`.includes(query.toLowerCase());
    });

    const handleAgregarProducto = () => {
        setProductosSeleccionados((prev) => [...prev, { producto: null, cantidad: "", cantidadNoCobrada: "", esSeña: false, descuento: 0 }]);
        setProductosQueries(prev => [...prev, '']);
    };

    const handleProductoChange = (index, nuevoProducto) => {
        setProductosSeleccionados((prev) => {
            const actualizados = [...prev];
            actualizados[index].producto = nuevoProducto;
            if (nuevoProducto && nuevoProducto.categoria === 'eventos' && prev.some((p, i) => i !== index && p.producto?.categoria === 'eventos')) return prev;
            if (nuevoProducto?.categoria === 'eventos') {
                actualizados[index].cantidad = "1";
                actualizados[index].cantidadNoCobrada = "";
                setPreciosEditables(prevPrices => prevPrices.filter((_, i) => i === index));
                return actualizados.filter((item, i) => i === index);
            } else if (actualizados[index].cantidad === "1" && actualizados[index].producto?.categoria !== 'eventos') {
                actualizados[index].cantidad = "";
            }
            return actualizados;
        });
        setPreciosEditables((prevPrices) => {
            const updatedPrices = [...prevPrices];
            if (nuevoProducto) updatedPrices[index] = { precio: formatNumberWithDots(String(nuevoProducto.precioUnidad).replace('.', ',')) };
            else updatedPrices[index] = { precio: "" };
            return updatedPrices;
        });
    };

    const handleProductoQueryChange = (index, newQuery) => {
        setProductosQueries(prev => { const updated = [...prev]; updated[index] = newQuery; return updated; });
    };

    const handleCategoriaChange = (index, nuevaCategoria) => {
        setCategoriasSeleccionadas(prev => { const updated = [...prev]; updated[index] = prev[index] === nuevaCategoria ? '' : nuevaCategoria; return updated; });
        setProductosQueries(prev => { const updated = [...prev]; updated[index] = ''; return updated; });
    };

    const handleEliminarProducto = (index) => {
        setProductosSeleccionados((prev) => {
            const updatedProducts = prev.filter((_, i) => i !== index);
            if (prev[index].producto?.categoria === 'eventos' && prev[index].esSeña && updatedProducts.every(item => !(item.producto?.categoria === 'eventos' && item.esSeña))) {
                setTipoFactura('');
            }
            if (updatedProducts.length === 0) return [{ producto: null, cantidad: "", cantidadNoCobrada: "", esSeña: false, descuento: 0 }];
            return updatedProducts;
        });
        setProductosQueries(prev => prev.filter((_, i) => i !== index));
    };

    const handlePrecioUnitarioChange = (index, nuevoPrecio) => {
        setPreciosEditables((prev) => { const updated = [...prev]; updated[index].precio = formatNumberWithDots(nuevoPrecio); return updated; });
    };

    const handleCantidadChange = (index, nuevaCantidad) => {
        setProductosSeleccionados((prev) => { const actualizados = [...prev]; actualizados[index].cantidad = formatNumberWithDots(nuevaCantidad); return actualizados; });
    };

    const handleCantidadNoCobradaChange = (index, nuevaCantidad) => {
        setProductosSeleccionados((prev) => { const actualizados = [...prev]; actualizados[index].cantidadNoCobrada = formatNumberWithDots(nuevaCantidad); return actualizados; });
    };

    // Actualizadas para usar obtenerProductosProcesados y contemplar los descuentos del 100%
    const calcularTotalBotellas = () => {
        return obtenerProductosProcesados().reduce((acc, item) => item.vino_id ? acc + item.cantidad : acc, 0);
    };

    const calcularTotalNeto = () => {
        return obtenerProductosProcesados().reduce((acc, item) => {
            const multiplier = (100 - item.descuento) / 100;
            return acc + (item.cantidad * item.precioUnidad * multiplier);
        }, 0);
    };

    const calcularIvaDiferenciado = () => {
        return obtenerProductosProcesados().reduce((acc, item) => {
            const multiplier = (100 - item.descuento) / 100;
            const subtotalNeto = item.cantidad * item.precioUnidad * multiplier;
            if (item.nombreProducto.startsWith('VIT')) return acc + (subtotalNeto * 0.105);
            return acc + (subtotalNeto * 0.21);
        }, 0);
    };

    const calcularIvaPorAlicuota = () => {
        let iva21 = 0; let iva10_5 = 0;
        obtenerProductosProcesados().forEach((item) => {
            const multiplier = (100 - item.descuento) / 100;
            const subtotalNeto = item.cantidad * item.precioUnidad * multiplier;
            if (item.nombreProducto.startsWith('VIT')) iva10_5 += subtotalNeto * 0.105;
            else iva21 += subtotalNeto * 0.21;
        });
        return { iva21, iva10_5 };
    };

    const calcularTotalCompletoConImpuestos = () => {
        const neto = calcularTotalNeto();
        if (['A', 'B', 'E'].includes(tipoFactura)) return neto + calcularIvaDiferenciado();
        return neto + calcularIvaDiferenciado();
    };

    const cajasX6Necesarias = Number(insumos.cajaX6) || 0;
    const cajasParaElegir = productos.filter(p => (p.nombre || p.id || '').trim().toLowerCase().startsWith('caja'));
    const cajaElegida = productos.find(p => p.id === cajaId);
    const cajaX6Disponible = cajaElegida ? Number(cajaElegida.cantidadUnidades || 0) : null;
    // Si la venta ya descontó stock, lo que hace falta pedirle al stock es sólo
    // la diferencia contra lo que se descontó de ese mismo ítem.
    const yaDescontadoDe = (itemId, idOriginal) => (
        insumosOriginales.cajaDescontada && itemId && itemId === idOriginal ? insumosOriginales.cajaX6 : 0
    );
    const cajasX6Faltantes = cajasX6Necesarias - yaDescontadoDe(cajaId, insumosOriginales.cajaId);
    const faltanCajasX6 = cajasX6Faltantes > 0 && cajaX6Disponible !== null && cajasX6Faltantes > cajaX6Disponible;
    
    const separadoresParaElegir = productos.filter(p => (p.nombre || p.id || '').trim().toLowerCase().startsWith('separador'));
    const separadorElegido = productos.find(p => p.id === separadorId);
    const separadorDisponible = separadorElegido ? Number(separadorElegido.cantidadUnidades || 0) : null;
    const separadoresFaltantes = cajasX6Necesarias - yaDescontadoDe(separadorId, insumosOriginales.separadorId);
    const faltanSeparadores = separadoresFaltantes > 0 && separadorDisponible !== null && separadoresFaltantes > separadorDisponible;

    const { iva21, iva10_5 } = calcularIvaPorAlicuota();
    const ivaTotal = iva21 + iva10_5;
    const totalFinal = tieneSeña()
        ? Math.floor(calcularTotalCompletoConImpuestos() / 2)
        : Math.floor(calcularTotalNeto() + (['A', 'B', 'E'].includes(tipoFactura) ? ivaTotal : 0));

const datosClienteParaImprimir = {
    ...(selectedCliente || {}),
    ...formData,
    personeria: personeria || selectedCliente?.personeria,
    ...(requiereEnvio ? direccionEntregaVenta : {})
};
    const tieneEmailCliente = Boolean((selectedCliente?.correoElectronico || formData.correoElectronico || '').trim());

    useEffect(() => {
        if (!tieneEmailCliente && enviarPorMail) {
            setEnviarPorMail(false);
        }
    }, [tieneEmailCliente, enviarPorMail]);

    if (loadingVenta) return <LoadingSpinner />;

    return (
        <div style={{ padding: '0 16px',overflow:'hidden',height:'100%' }}>
            {isLoading && (
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000, transition: 'opacity 0.3s' }}>
                    <LoadingSpinner />
                </div>
            )}
            <header className="trazabilidad-header">
                <div className="header-content"><h1>Ventas</h1></div>
            </header>
            <div className="container" style={{ margin: '0 10px' }}>
                <div className="formtitle-container">
                    <div className="formicon-container">
                        <VentasIcon className="formicon" style={{ height: '20px', margin: 'auto' }} />
                    </div>
                    <h1 className="formtitle">{isEditing ? 'Editar venta' : 'Generar una venta'}</h1>
                </div>
                <hr className="divider" />
                <form onSubmit={handleSubmit} className="form" >
                    <div className="columns-container">
                        <div className={`column${isEditing && requiereEnvio ? '' : ' long'}`}>
                            <div className="input-group">
                                <Combobox value={selectedCliente} onChange={handleClienteSelect}>
                                    {({ open }) => (
                                        <>
                                            <div className="relative">
                                                <Combobox.Button as="div" style={{ width: '92.75%' }} className={`custom-listbox-button ${open ? 'open' : ''} ${selectedCliente ? 'selected' : 'placeholder'}`}>
                                                    <Combobox.Input
                                                        className="custom-combobox-input"
                                                        displayValue={(cliente) => cliente ? (cliente.personeria === 'persona fisica' ? `${cliente.nombre} ${cliente.apellido}` : cliente.razonSocial) : ''}
                                                        onChange={(event) => setQuery(event.target.value)}
                                                        onKeyDown={permitirEspacioEnBusqueda}
                                                        placeholder="Buscar o seleccionar cliente"
                                                        style={{ flexGrow: 1, padding: '0', border: 'none', outline: 'none', backgroundColor: 'transparent' }}
                                                    />
                                                    <span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                                </Combobox.Button>
                                                <Combobox.Options className="custom-listbox-options" style={{ maxHeight: '175px',width:'100%'}}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', margin: '0 auto', gap: '5px', position: 'sticky', top: '0', backgroundColor: '#f6f7fa', padding: '0 15px 5px' }}>
                                                        <button type="button" onClick={() => setPersoneriaFilter(personeriaFilter === 'persona fisica' ? '' : 'persona fisica')} style={{ flexGrow: 0, padding:'2px 15px' }} className={`filter-button ${personeriaFilter === 'persona fisica' ? 'active' : ''}`}>Persona Física</button>
                                                        <button type="button" onClick={() => setPersoneriaFilter(personeriaFilter === 'persona juridica' ? '' : 'persona juridica')} style={{ flexGrow: 0, padding:'2px 15px' }} className={`filter-button ${personeriaFilter === 'persona juridica' ? 'active' : ''}`}>Persona Jurídica</button>
                                                    </div>
                                                    <Combobox.Option value={null} className="custom-listbox-option">Nuevo cliente</Combobox.Option>
                                                    {filteredClientes.length === 0 && query !== '' ? (
                                                        <div className="custom-listbox-option empty-state">No se encontró nada.</div>
                                                    ) : (
                                                        filteredClientes.map((cliente) => (
                                                            <Combobox.Option key={cliente.id} value={cliente} className={({ active }) => `custom-listbox-option ${active ? 'active' : ''}`}>
                                                                {cliente.personeria === 'persona fisica' ? `${cliente.nombre} ${cliente.apellido}` : cliente.razonSocial}
                                                            </Combobox.Option>
                                                        ))
                                                    )}
                                                </Combobox.Options>
                                            </div>
                                        </>
                                    )}
                                </Combobox>
                            </div>
                            <div className="input-group">
                                <Listbox value={personeria} onChange={handlePersoneriaChange}>
                                    {({ open }) => (
                                        <>
                                            <Listbox.Button className={`custom-listbox-button ${open ? 'open' : ''} ${!personeria ? 'placeholder' : ''}${marcarFaltante('personeria')}`}>
                                                {personeriaOptions.find(opt => opt.value === personeria)?.label || "Personería"}
                                                <span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                            </Listbox.Button>
                                            <Listbox.Options className="custom-listbox-options">
                                                {personeriaOptions.map((option) => (
                                                    <Listbox.Option key={option.value} value={option.value} className="custom-listbox-option">{option.label}</Listbox.Option>
                                                ))}
                                            </Listbox.Options>
                                        </>
                                    )}
                                </Listbox>
                            </div>
                            {personeria && (
                                <>
                                    {personeria === 'persona fisica' && (
                                        <>
                                            <div className="input-group"><input type="text" name="nombre" value={formData.nombre} onChange={handleChange} placeholder="Nombre" required={!isEditing} className={`input${marcarFaltante('nombre')}`} /></div>
                                            <div className="input-group"><input type="text" name="apellido" value={formData.apellido} onChange={handleChange} placeholder="Apellido" required={!isEditing} className={`input${marcarFaltante('apellido')}`} /></div>
                                            <label className='data-label'>Fecha de nacimiento</label>
                                            <div className="input-group"><input type="text" inputMode="numeric" name="fechaDeNacimiento" value={formData.fechaDeNacimiento} onChange={handleChange} placeholder="dd/mm/aaaa" className="input" /></div>
                                            <label className='data-label'>TIPO Y NÚMERO DE DOCUMENTO</label>
                                            <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                                                <div className="input-group">
                                                    <Listbox value={formData.tipo} onChange={(value) => handleChange({ target: { name: 'tipo', value } })}>
                                                        {({ open }) => (
                                                            <>
                                                                <ListboxButton style={{ width: '150px' }} className={`custom-listbox-button ${open ? 'open' : ''} ${!formData.tipo ? 'placeholder' : ''}${marcarFaltante('tipo')}`}>
                                                                    {formData.tipo || "Tipo"}<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                                                </ListboxButton>
                                                                <ListboxOptions className="custom-listbox-options">
                                                                    {tipoDocumentoOptions.map((option) => (<ListboxOption key={option.value} value={option.value} className="custom-listbox-option">{option.label}</ListboxOption>))}
                                                                </ListboxOptions>
                                                            </>
                                                        )}
                                                    </Listbox>
                                                </div>
                                                <input type="text" name="numeroDeDocumento" value={formData.numeroDeDocumento} onChange={handleChange} placeholder="Número" required={!isEditing} className={`input-address${marcarFaltante('numeroDeDocumento')}`} style={{ width: '75%', textAlign: 'left' }} />
                                            </div>
                                        </>
                                    )}
                                    {personeria === 'persona juridica' && (
                                        <>
                                            <div className="input-group"><input type="text" name="razonSocial" value={formData.razonSocial} onChange={handleChange} placeholder="Razón Social" required={!isEditing} className={`input${marcarFaltante('razonSocial')}`} /></div>
                                            <div className="input-group"><input type="text" name="cuit" value={formData.cuit} onChange={handleChange} placeholder="CUIT" required={!isEditing} className={`input${marcarFaltante('cuit')}`} /></div>
                                        </>
                                    )}
                                    {!requiereEnvio && (
                                        <>
                                            <span className="data-label">Domicilio de residencia</span>
                                            <div className="input-group"><input type="text" name="calle" placeholder="Calle" value={formData.calle} onChange={handleChange} className="input" /></div>
                                            <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                                                <input type="text" name="altura" placeholder="Altura" value={formData.altura} onChange={handleChange} className="input-address" />
                                                <input type="text" name="piso" placeholder="Piso" value={formData.piso} onChange={handleChange} className="input-address" />
                                                <input type="text" name="unidad" placeholder="Unidad" value={formData.unidad} onChange={handleChange} className="input-address" />
                                                <input type="text" name="codigoPostal" placeholder="CP" value={formData.codigoPostal} onChange={handleChange} className="input-address" />
                                            </div>
                                            <div className="input-group"><input type="text" name="ciudad" placeholder="Ciudad / Localidad / Provincia" value={formData.ciudad} onChange={handleChange} className="input" /></div>
                                            <div className="input-group"><input type="text" name="pais" placeholder="País" value={formData.pais} onChange={handleChange} className="input" /></div>
                                        </>
                                    )}
                                    <div className="input-group"><input type="tel" name="telefono" value={formData.telefono} onChange={handleChange} placeholder="Teléfono" className={`input${marcarFaltante('telefono')}`} /></div>
                                    <div className="input-group"><input type="email" name="correoElectronico" value={formData.correoElectronico} onChange={handleChange} placeholder="Correo electrónico" className={`input${marcarFaltante('correoElectronico')}`} /></div>
                                </>
                            )}
                        </div>

                        <div className="column long">
<fieldset disabled={isEditing} style={{ border: 'none', padding: 0, margin: 0, display: 'contents' }}>
    {isEditing ? (() => {
        // Agrupar líneas por ID de producto (o nombre si es evento)
        const itemsAgrupados = productosSeleccionados.reduce((acc, item) => {
            if (!item.producto) return acc;
            const key = item.producto.id || item.producto.nombre;
            const cantidad = Number(normalizePrice(item.cantidad)) || 0;
            const esRegalo = item.descuento === 100;
            const precioUni = Number(item.producto?.precioUnidad || preciosEditables[0]?.precio || 0);

            if (!acc[key]) {
                acc[key] = {
                    producto: item.producto,
                    cantidadTotal: 0,
                    cantidadSinCargo: 0,
                    precioUnidad: precioUni,
                    isEvento: item.producto.categoria === 'eventos'
                };
            }

            acc[key].cantidadTotal += cantidad;
            if (esRegalo) {
                acc[key].cantidadSinCargo += cantidad;
            } else if (precioUni > 0) {
                acc[key].precioUnidad = precioUni;
            }

            return acc;
        }, {});

        return Object.values(itemsAgrupados).map((item, index) => {
            const unidadTexto = item.isEvento ? '' : item.producto.tipoUnidad === 'Quintales' ? 'q' : item.producto.tipoUnidad === 'Hectolitros' ? 'hl' : 'botellas';
            const cantidadCobrada = Math.max(0, item.cantidadTotal - item.cantidadSinCargo);
            const subtotal = Math.floor(item.isEvento ? item.precioUnidad : cantidadCobrada * item.precioUnidad);

            return (
                <div key={index} className="column" style={{ gap: '4px', marginBottom: '14px' }}>
                    <p className="data-p" style={{ fontWeight: 600, margin: 0 }}>
                        {item.producto.nombre}
                    </p>
                    <p className="data-p" style={{ margin: 0, color: '#555' }}>
                        {item.isEvento ? 1 : item.cantidadTotal} {unidadTexto}
                        {item.cantidadSinCargo > 0 && !item.isEvento && (
                            <span style={{ color: '#777', fontWeight: 'normal', marginLeft: '6px' }}>
                                ({item.cantidadSinCargo} sin cargo)
                            </span>
                        )}
                    </p>
                    {item.precioUnidad > 0 && (
                        <p className="data-p" style={{ margin: 0, fontSize: '13px', color: '#666' }}>
                            ${item.precioUnidad.toLocaleString('es-AR')} c/u
                        </p>
                    )}
                    {subtotal > 0 && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '6px' }}>
                            <label className="data-label" style={{ margin: 0 }}>Subtotal (100% Neto)</label>
                            <p className="data-p" style={{ fontSize: '24px', lineHeight: '24px', margin: 0 }}>
                                ${subtotal.toLocaleString('es-AR')}
                            </p>
                        </div>
                    )}
                </div>
            );
        });
    })() : (
        productosSeleccionados.map((item, index) => {
            const isEvento = item.producto?.categoria === 'eventos';
            const filteredProductos = productos.filter((producto) => {
                const queryEnNombre = producto.nombre.toLowerCase().includes(productosQueries[index]?.toLowerCase() || '');
                const categoriaSeleccionada = categoriasSeleccionadas[index];
                if (categoriaSeleccionada === '' && productosQueries[index] === '') return true;
                if (['vinos', 'VIN', 'VIT', 'eventos'].includes(categoriaSeleccionada)) return producto.categoria === categoriaSeleccionada && queryEnNombre;
                else if (categoriaSeleccionada === 'TRAZ') return producto.nombre.toUpperCase().startsWith('TRAZ') && queryEnNombre;
                else if (categoriaSeleccionada === 'Stock') return producto.categoria === 'Stock' && queryEnNombre;
                return queryEnNombre;
            });

            // Cálculos Visuales en tiempo real para la interfaz
            const cantidadTotalUI = normalizePrice(item.cantidad);
            const cantidadNoCobradaUI = normalizePrice(item.cantidadNoCobrada) || 0;
            const cantidadCobradaUI = Math.max(0, cantidadTotalUI - cantidadNoCobradaUI);

            const subtotal100PorCiento = item.producto && (cantidadCobradaUI > 0 || isEvento)
                ? Math.floor(isEvento ? (getPrecioUnitario(index, item) * 1) : (cantidadCobradaUI * getPrecioUnitario(index, item)))
                : 0;

            return (
                <div key={index} className="column" style={{gap:'5px'}}>
                    <div className="input-group">
                        <Combobox value={item.producto} onChange={(value) => handleProductoChange(index, value)} nullable disabled={tieneEvento() && productosSeleccionados.length > 1 && !item.producto}>
                            {({ open }) => (
                                <div className="relative">
                                    <Combobox.Button as="div" style={{ width: '92.75%',position:'relative' }} className={`custom-listbox-button ${open ? 'open' : ''} ${!item.producto ? 'placeholder' : ''}${marcarFaltante(`producto-${index}`)}`}>
                                        <Combobox.Input
                                            className="custom-combobox-input"
                                            displayValue={(producto) => producto?.nombre || ''}
                                            onChange={(event) => handleProductoQueryChange(index, event.target.value)}
                                            onKeyDown={permitirEspacioEnBusqueda}
                                            placeholder="Seleccionar producto"
                                            style={{ flexGrow: 1, padding: '0', border: 'none', outline: 'none', backgroundColor: 'transparent' }}
                                        />
                                        <span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                    </Combobox.Button>
                                    <Combobox.Options className="custom-listbox-options" style={{ maxHeight: '175px',width:'100%'}}>
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between', margin: '0 auto', gap: '5px', position: 'sticky', top: '0', backgroundColor: '#f6f7fa', padding: '0 15px 5px' }}>
                                            <button type="button" onClick={() => handleCategoriaChange(index, 'vinos')} style={{ flexGrow: '1' }} className={`filter-button ${categoriasSeleccionadas[index] === 'vinos' ? 'active' : ''}`}>Vinos</button>
                                            <button type="button" onClick={() => handleCategoriaChange(index, 'VIN')} style={{ flexGrow: '1' }} className={`filter-button ${categoriasSeleccionadas[index] === 'VIN' ? 'active' : ''}`}>VIN</button>
                                            <button type="button" onClick={() => handleCategoriaChange(index, 'VIT')} style={{ flexGrow: '1' }} className={`filter-button ${categoriasSeleccionadas[index] === 'VIT' ? 'active' : ''}`}>VIT</button>
                                            <button type="button" onClick={() => handleCategoriaChange(index, 'TRAZ')} style={{ flexGrow: '1' }} className={`filter-button ${categoriasSeleccionadas[index] === 'TRAZ' ? 'active' : ''}`}>TRAZ</button>
                                            <button type="button" onClick={() => handleCategoriaChange(index, 'eventos')} style={{ flexGrow: '1' }} className={`filter-button ${categoriasSeleccionadas[index] === 'eventos' ? 'active' : ''}`}>Eventos</button>
                                        </div>
                                        {filteredProductos.length === 0 && productosQueries[index] !== '' ? (
                                            <div className="custom-listbox-option empty-state">No se encontró nada.</div>
                                        ) : (
                                            filteredProductos.map((producto) => (
                                                <Combobox.Option key={producto.id} value={producto} className={({ active }) => `custom-listbox-option ${active ? 'active' : ''}`} disabled={tieneEvento() && producto.categoria !== 'eventos'}>
                                                    {producto.nombre}
                                                </Combobox.Option>
                                            ))
                                        )}
                                    </Combobox.Options>
                                </div>
                            )}
                        </Combobox>
                    </div>
                    {item.producto && (
                        <>
                            {!isEvento && (
                                <>
                                    <label className="data-label" style={{ marginTop: '5px' }}>Existencias disponibles</label>
                                    <p className="data-p" style={{ textTransform: 'lowercase' }}>{item.producto.cantidadUnidades} {item.producto.tipoUnidad ? item.producto.tipoUnidad : 'botellas'}</p>
                                </>
                            )}
                            <label className="data-label" style={{ marginTop: isEvento ? '5px' : '0' }}>Precio unitario</label>
                            <div className="input-group number" style={{ maxWidth: '160px', margin:'3px 0 10px' }}>
                                <input type="text" value={preciosEditables[index]?.precio || ''} onChange={(e) => handlePrecioUnitarioChange(index, e.target.value)} className="input" placeholder="Precio" />
                                <span className='unit'>$</span>
                            </div>
                            {!isEvento && (
                                <>
                                    <label className="data-label" style={{margin:'5px 0 0px'}}>Cantidad total a entregar</label>
                                    {/* El borde rojo va en el contenedor y no en el input: el input es un
                                        rectángulo dentro de la pastilla redondeada, así que marcarlo a él
                                        dibujaría un recuadro cortado adentro del campo. */}
                                    <div className={`input-group number${marcarFaltante(`cantidad-${index}`)}`} style={{ maxWidth: '160px' }}>
                                        <input placeholder="Cantidad total" type="text" value={item.cantidad} onChange={(e) => handleCantidadChange(index, e.target.value)} className="input" />
                                        <span className='unit'>{item.producto.tipoUnidad === 'Quintales' ? 'q' : item.producto.tipoUnidad === 'Hectolitros' ? 'hl' : 'u'}</span>
                                    </div>

                                    <label className="data-label" style={{margin:'5px 0 0px'}}>Cantidad sin cargo</label>
                                    <div className="input-group number" style={{ maxWidth: '160px' }}>
                                        <input placeholder="Ej. 2" type="text" value={item.cantidadNoCobrada} onChange={(e) => handleCantidadNoCobradaChange(index, e.target.value)} className="input" />
                                        <span className='unit'>{item.producto.tipoUnidad === 'Quintales' ? 'q' : item.producto.tipoUnidad === 'Hectolitros' ? 'hl' : 'u'}</span>
                                    </div>
                                </>
                            )}
                            {(cantidadCobradaUI > 0 || isEvento) && (
                                <div style={{display:'flex', flexDirection:'column',gap:'10px'}}>
                                    <label className="data-label" style={{ marginTop: "10px" }}>Subtotal (100% Neto)</label>
                                    <p className="data-p" style={{ fontSize: '30px', lineHeight: '20px', margin: '0' }}>
                                        ${subtotal100PorCiento.toLocaleString('es-AR')}
                                    </p>
                                </div>
                            )}
                            {isEvento && (
                                <div className="input-group" style={{ display: 'flex', alignItems: 'center', marginTop: '10px',flexDirection:'row' }}>
                                    <button
                                        type="button"
                                        className={`check-circle ${item.esSeña ? "done" : ""}`}
                                        onClick={() => {
                                            const isChecked = !item.esSeña; 
                                            const nuevosProductos = [...productosSeleccionados];
                                            nuevosProductos[index].esSeña = isChecked;
                                            setProductosSeleccionados(nuevosProductos);
                                        }}
                                        title={item.esSeña ? "Quitar seña" : "Marcar como seña"} 
                                        style={{ marginRight: '8px' }}
                                    />
                                    <label htmlFor={`seña-${index}`} className="data-label" style={{ marginBottom: '0',color:'#2c2c2c' }}>Es una seña (50%)</label>
                                </div>
                            )}
                            <div style={{display:'flex', padding:'10px 0 0'}}>
                                <button type="button" className='remove-btn' onClick={() => handleEliminarProducto(index)} style={{ margin: '0 0 0 auto' }}>Eliminar artículo</button>
                            </div>
                        </>
                    )}
                </div>
            );
        })
    )}
    {!isEditing && productosSeleccionados.some(item => item.producto) && !tieneEvento() && (
        <div type="button" onClick={handleAgregarProducto} className="add-btn-container">
            <span className="add-icon">+</span><span className="add-txt">Agregar otro artículo</span>
        </div>
    )}
</fieldset>
                            {productosSeleccionados.some(item => item.producto && item.producto.vino_id) && (
                                <>
                                    <>
                                            <label className="data-label" style={{ marginTop: '15px' }}>INSUMOS UTILIZADOS</label>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                                {(
                                                    <div className="input-group">
                                                        <Listbox value={cajaId} onChange={setCajaId}>
                                                            {({ open }) => (
                                                                <>
                                                                    <ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${!cajaId ? 'placeholder' : ''}`}>
                                                                        <span className="listbox-button-label">{cajaElegida ? cajaElegida.nombre : 'Elegir caja'}</span>
                                                                        <span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                                                    </ListboxButton>
                                                                    <ListboxOptions className="custom-listbox-options">
                                                                        {cajasParaElegir.map((c) => (
                                                                            <ListboxOption key={c.id} value={c.id} className="custom-listbox-option">
                                                                                {c.nombre || c.id}
                                                                                <span style={{ color: '#999', fontSize: '12px', marginLeft: '8px' }}>{Number(c.cantidadUnidades || 0).toLocaleString('es-AR')} u.</span>
                                                                            </ListboxOption>
                                                                        ))}
                                                                    </ListboxOptions>
                                                                </>
                                                            )}
                                                        </Listbox>
                                                    </div>
                                                )}
                                                <p className="data-p" style={{ margin: 0, ...(faltanCajasX6 ? { color: '#e65c5c' } : {}) }}>
                                                    {cajasX6Necesarias} {cajasX6Necesarias === 1 ? 'caja x 6' : 'cajas x 6'}
                                                    {faltanCajasX6 && ` — sin stock suficiente (quedan ${cajaX6Disponible})`}
                                                </p>
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '5px' }}>
                                                {(
                                                    <div className="input-group">
                                                        <Listbox value={separadorId} onChange={setSeparadorId}>
                                                            {({ open }) => (
                                                                <>
                                                                    <ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${!separadorId ? 'placeholder' : ''}`}>
                                                                        <span className="listbox-button-label">{separadorElegido ? separadorElegido.nombre : 'Elegir separador'}</span>
                                                                        <span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                                                    </ListboxButton>
                                                                    <ListboxOptions className="custom-listbox-options">
                                                                        {separadoresParaElegir.map((s) => (
                                                                            <ListboxOption key={s.id} value={s.id} className="custom-listbox-option">
                                                                                {s.nombre || s.id}
                                                                                <span style={{ color: '#999', fontSize: '12px', marginLeft: '8px' }}>{Number(s.cantidadUnidades || 0).toLocaleString('es-AR')} u.</span>
                                                                            </ListboxOption>
                                                                        ))}
                                                                    </ListboxOptions>
                                                                </>
                                                            )}
                                                        </Listbox>
                                                    </div>
                                                )}
                                                <p className="data-p" style={{ margin: 0, ...(faltanSeparadores ? { color: '#e65c5c' } : {}) }}>
                                                    {cajasX6Necesarias} {cajasX6Necesarias === 1 ? 'separador' : 'separadores'}
                                                    {faltanSeparadores && ` — sin stock suficiente (quedan ${separadorDisponible})`}
                                                </p>
                                            </div>
                                    </>
                                </>
                            )}
                        </div>
                        <div className="column long">
                            {(!tieneSeña() && tipoFactura === 'A') && (
                                <>
                                    <label className="data-label" style={{ color: '#e65c5c' }}>Total neto (100%)</label>
                                    <p className="data-p" style={{ fontSize: '24px', lineHeight: '20px', margin: '0' }}>${calcularTotalNeto().toLocaleString('es-AR')}</p>
                                    {iva21 > 0 && (
                                        <><label className="data-label" style={{ color: '#e65c5c' }}>IVA (21%)</label><p className="data-p" style={{ fontSize: '24px', lineHeight: '20px', margin: '0' }}>${iva21.toLocaleString('es-AR')}</p></>
                                    )}
                                    {iva10_5 > 0 && (
                                        <><label className="data-label" style={{ color: '#e65c5c' }}>IVA (10.5%)</label><p className="data-p" style={{ fontSize: '24px', lineHeight: '20px', margin: '0' }}>${iva10_5.toLocaleString('es-AR')}</p></>
                                    )}
                                    <hr className="divider" />
                                </>
                            )}
                            <label className="data-label" style={{ color: '#e65c5c' }}>
                                TOTAL A FACTURAR {['A', 'B', 'E'].includes(tipoFactura) ? ' (IVA incluido)' : tipoFactura === 'R' ? ' (50%)' : ' s/ impuestos'}
                            </label>
                            <p className="data-p" style={{ fontSize: '34px', lineHeight: '20px', margin: '0' }}>{totalFinal.toLocaleString('es-AR')}</p>
                            
                            {!(isEditing && requiereEnvio) && (
                                <>
                                    {tipoFactura !== 'R' && (
                                        <div className="input-group">
                                            <Listbox value={tipoFactura} onChange={setTipoFactura} disabled={isEditing}>
                                                {({ open }) => (
                                                    <>
                                                        <ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${!tipoFactura ? 'placeholder' : ''}${marcarFaltante('tipoFactura')}`}>
                                                            {tipoFactura || "Tipo de factura"}<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                                        </ListboxButton>
                                                        <ListboxOptions className="custom-listbox-options">
                                                            {tiposFactura.map((tipo) => (<ListboxOption key={tipo} value={tipo} className="custom-listbox-option">{tipo}</ListboxOption>))}
                                                        </ListboxOptions>
                                                    </>
                                                )}
                                            </Listbox>
                                        </div>
                                    )}
                                    <div className="input-group">
                                        <Listbox value={modalidadPago} onChange={handleModalidadPagoChange}>
                                            {({ open }) => (
                                                <>
                                                    <ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${!modalidadPago ? 'placeholder' : ''}${marcarFaltante('modalidadPago')}`}>
                                                        {modalidadPago || "Modalidad de pago"}<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                                    </ListboxButton>
                                                    <ListboxOptions className="custom-listbox-options">
                                                        {modalidadesPago.map((modalidad) => (<ListboxOption key={modalidad} value={modalidad} className="custom-listbox-option">{modalidad}</ListboxOption>))}
                                                    </ListboxOptions>
                                                </>
                                            )}
                                        </Listbox>
                                    </div>
                                    {modalidadPago === 'Cheque' && (
                                        <>
                                            <label className="data-label" style={{ marginTop: '10px' }}>DATOS DEL CHEQUE</label>
                                            <div className="input-group"><input type="text" name="numeroCheque" value={datosCheque.numeroCheque} onChange={handleChequeChange} placeholder="Número de Cheque" required className={`input${marcarFaltante('cheque-numeroCheque')}`} /></div>
                                            <div className="input-group"><input type="text" name="bancoEmisor" value={datosCheque.bancoEmisor} onChange={handleChequeChange} placeholder="Banco Emisor" required className={`input${marcarFaltante('cheque-bancoEmisor')}`} /></div>
                                            <label className='data-label'>Fecha de vencimiento</label>
                                            <div className="input-group"><input type="text" inputMode="numeric" name="fechaVencimiento" value={datosCheque.fechaVencimiento} onChange={handleChequeChange} placeholder="dd/mm/aaaa" required className={`input${marcarFaltante('cheque-fechaVencimiento')}`} /></div>
                                        </>
                                    )}
{modalidadPago === 'Transferencia' && (
    <div className="input-group">
        <label className='date-label'>Adjuntar comprobante</label>
        <div style={{ display: 'flex',flexDirection: 'column', alignItems: 'start', gap: '5px', flexWrap: 'wrap' }}>
            <button type="button" onClick={handleComprobanteButtonClick} className="pdf-button">
                <ClipIcon style={{ height: '15px' }} /> Seleccionar archivo
            </button>
            <input type="file" accept="application/pdf,image/*" onChange={handleComprobanteFileChange} ref={comprobanteInputRef} style={{ display: 'none' }} />
            
            {comprobanteTransferencia && (
                <p style={{ margin: 0, cursor: 'default', fontSize: '13px', fontFamily: 'Effra', display: 'flex', alignItems: 'center', gap: '8px', color: '#2c2c2c' }}>
                    {comprobanteTransferencia.name}<span className='no-pdf' onClick={() => setComprobanteTransferencia(null)}>×</span>
                </p>
            )}

            {isEditing && !comprobanteTransferencia && comprobanteTransferenciaUrl && (
                <a 
                    href={comprobanteTransferenciaUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ 
                        fontSize: '13px', 
                        fontFamily: 'Effra', 
                        color: '#6b7280', 
                        textDecoration: 'none', 
                        fontWeight: 500,
                        marginLeft: '10px',
                    }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#111827'}
        onMouseLeave={(e) => e.currentTarget.style.color = '#6b7280'}
    >
                    Ver comprobante actual
                </a>
            )}
        </div>
    </div>
)}
                                    {modalidadPago === 'Contado' && (
                                        <div className="input-group">
                                            <Listbox value={tipoDivisa} onChange={setTipoDivisa}>
                                                {({ open }) => (
                                                    <>
                                                        <ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${!tipoDivisa ? 'placeholder' : ''}`}>
                                                            {tipoDivisa || "Tipo de divisa"}<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                                        </ListboxButton>
                                                        <ListboxOptions className="custom-listbox-options">
                                                            {tiposDivisa.map((divisa) => (<ListboxOption key={divisa} value={divisa} className="custom-listbox-option">{divisa}</ListboxOption>))}
                                                        </ListboxOptions>
                                                    </>
                                                )}
                                            </Listbox>
                                        </div>
                                    )}
                                </>
                            )}
                            <label className="data-label" style={{ marginTop: '10px' }}>Estado</label>
                            <div className="input-group">
                                <Listbox value={estado} onChange={setEstado}>
                                    {({ open }) => (
                                        <>
                                            <ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${!estado ? 'placeholder' : ''}`}>
                                                {estado || "Estado"}<span className="custom-arrow-container"><span className="custom-arrow"></span></span>
                                            </ListboxButton>
                                            <ListboxOptions className="custom-listbox-options">
                                                {estadosVenta.map((op) => (<ListboxOption key={op} value={op} className="custom-listbox-option">{op}</ListboxOption>))}
                                            </ListboxOptions>
                                        </>
                                    )}
                                </Listbox>
                            </div>
<div style={{ display: 'flex', flexDirection: 'row', gap: '30px', alignItems: 'center', marginTop: '10px', flexWrap: 'wrap' }}>                         
<div className="input-group" style={{ display: 'flex', alignItems: 'center', margin: '0', flexDirection: 'row' }}>
    <button 
        type="button" 
        disabled={!tieneEmailCliente}
        className={`check-circle ${enviarPorMail ? "done" : ""}`} 
        onClick={() => setEnviarPorMail(!enviarPorMail)} 
        title={!tieneEmailCliente ? "El cliente no tiene un correo electrónico cargado" : (enviarPorMail ? "No enviar por mail" : "Enviar factura por mail")} 
        style={{ 
            marginRight: '8px', 
            width: '17px', 
            height: '17px',
            opacity: tieneEmailCliente ? 1 : 0.4,
            cursor: tieneEmailCliente ? 'pointer' : 'not-allowed'
        }} 
    />
    <label 
        className="data-label" 
        style={{ 
            marginBottom: '0', 
            color: tieneEmailCliente ? '#2c2c2c' : '#999',
            cursor: tieneEmailCliente ? 'pointer' : 'not-allowed'
        }}
    >
        Enviar factura por mail
    </label>
</div>
<div className="input-group" style={{ display: 'flex', alignItems: 'center', margin: '0', flexDirection: 'row' }}>
        <button type="button" className={`check-circle ${requiereEnvio ? "done" : ""}`} onClick={() => setRequiereEnvio(!requiereEnvio)} title={requiereEnvio ? "Ya no requiere envío" : "Marcar que requiere envío"} style={{ marginRight: '8px', width: '17px', height: '17px' }} />
        <label className="data-label" style={{ marginBottom: '0', color: '#2c2c2c' }}>Requiere envío</label>
    </div>

    </div>
    
                            {requiereEnvio && (
                                <>
                                    <label className='data-label'>Domicilio de entrega</label>
                                    <div className="input-group"><input type="text" placeholder="Calle" value={direccionEntregaVenta.calle} onChange={handleDireccionEntregaChange('calle')} className={`input${marcarFaltante('envio-calle')}`} /></div>
                                    <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                                        <input type="text" placeholder="Número" value={direccionEntregaVenta.altura} onChange={handleDireccionEntregaChange('altura')} className="input-address" />
                                        <input type="text" placeholder="Piso" value={direccionEntregaVenta.piso} onChange={handleDireccionEntregaChange('piso')} className="input-address" />
                                        <input type="text" placeholder="Unidad" value={direccionEntregaVenta.unidad} onChange={handleDireccionEntregaChange('unidad')} className="input-address" />
                                        <input type="text" placeholder="CP" value={direccionEntregaVenta.codigoPostal} onChange={handleDireccionEntregaChange('codigoPostal')} className="input-address" />
                                    </div>
                                    <div className="input-group"><input type="text" placeholder="Ciudad / Localidad / Provincia" value={direccionEntregaVenta.ciudad} onChange={handleDireccionEntregaChange('ciudad')} className={`input${marcarFaltante('envio-ciudad')}`} /></div>
                                    <div className="input-group"><input type="text" placeholder="País" value={direccionEntregaVenta.pais} onChange={handleDireccionEntregaChange('pais')} className="input" /></div>
                                    <label className="data-label">Observaciones</label>
                                    <div className="eventos-form-input-group" style={{ display: 'flex', gap: '0', flexDirection: 'column', borderRadius: '7px', backgroundColor: '#f6f7fa' }}>
                                        <textarea className="eventos-form-input eventos-form-large-input" placeholder="Instrucciones de entrega (ej. horarios, no anda el timbre)" value={direccionEntregaVenta.observaciones} onChange={handleDireccionEntregaChange('observaciones')} rows={3} />
                                    </div>
                                    <div className="input-group"><input type="text" placeholder="N° de guía" value={numeroGuia} onChange={(e) => setNumeroGuia(e.target.value)} className="input" /></div>
                                    <label className='data-label'>Empresa de transporte</label>
                                    <div className="input-group">
                                        <Combobox value={selectedTransportista} onChange={(value) => { setSelectedTransportista(value); if (!value) { setNuevoTransportista({ razonSocial: '', rubro: 'Transporte', cuit: '', calle: '', altura: '', piso: '', unidad: '', codigoPostal: '', ciudad: '', pais: '', telefono: '', correoElectronico: '', nombreVendedor: '' }); } }}>
                                            {({ open }) => (
                                                <>
                                                    <div style={{ position: 'relative' }}>
                                                        <Combobox.Button as="div" className={`custom-listbox-button ${open ? 'open' : ''} ${selectedTransportista ? 'selected' : 'placeholder'}${marcarFaltante('envio-transportista')}`} style={{ paddingLeft: '0', paddingRight: '0' }}>
                                                            <Combobox.Input className="custom-combobox-input" onChange={(event) => setTransportistaQuery(event.target.value)} onKeyDown={permitirEspacioEnBusqueda} displayValue={(p) => p?.razonSocial || ''} placeholder="Selecciona o busca una transportista" style={{ flexGrow: 1, padding: '0', marginLeft: '15px', border: 'none', outline: 'none', backgroundColor: 'transparent' }} />
                                                            <span className="custom-arrow-container" style={{ marginRight: '5px' }}><span className="custom-arrow"></span></span>
                                                        </Combobox.Button>
                                                        <Combobox.Options className="custom-listbox-options">
                                                            <Combobox.Option className="custom-listbox-option" key="nuevo" value={null}>Nuevo proveedor</Combobox.Option>
                                                            {(() => {
                                                                const transportistas = proveedores.filter(p => (p.rubro || '').trim().toLowerCase() === 'transporte');
                                                                const filtradas = transportistaQuery === '' ? transportistas : transportistas.filter(p => (p.razonSocial || '').toLowerCase().includes(transportistaQuery.toLowerCase()));
                                                                return filtradas.length === 0 && transportistaQuery !== '' ? (
                                                                    <div className="custom-listbox-option">No se encontraron transportistas.</div>
                                                                ) : ( filtradas.map((p) => ( <Combobox.Option key={p.cuit} value={p} className={({ active }) => `custom-listbox-option ${active ? 'active' : ''}`}>{p.razonSocial}</Combobox.Option> )) );
                                                            })()}
                                                        </Combobox.Options>
                                                    </div>
                                                </>
                                            )}
                                        </Combobox>
                                    </div>
                                    {!selectedTransportista && (
                                        <>
                                            <div className="input-group"><input type="text" name="razonSocial" placeholder="Razón social" value={nuevoTransportista.razonSocial} onChange={handleNuevoTransportistaChange} className="input" /></div>
                                            <div className="input-group"><input type="text" name="cuit" placeholder="CUIT" value={nuevoTransportista.cuit} onChange={handleTransportistaCuitChange} maxLength={13} className="input" /></div>
                                            <div className="input-group"><input type="text" name="calle" placeholder="Calle" value={nuevoTransportista.calle} onChange={handleNuevoTransportistaChange} className="input" /></div>
                                            <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                                                <input type="text" name="altura" placeholder="Número" value={nuevoTransportista.altura} onChange={handleNuevoTransportistaChange} className="input-address" />
                                                <input type="text" name="piso" placeholder="Piso" value={nuevoTransportista.piso} onChange={handleNuevoTransportistaChange} className="input-address" />
                                                <input type="text" name="unidad" placeholder="Unidad" value={nuevoTransportista.unidad} onChange={handleNuevoTransportistaChange} className="input-address" />
                                                <input type="text" name="codigoPostal" placeholder="CP" value={nuevoTransportista.codigoPostal} onChange={handleNuevoTransportistaChange} className="input-address" />
                                            </div>
                                            <div className="input-group"><input type="text" name="ciudad" placeholder="Ciudad / Localidad / Provincia" value={nuevoTransportista.ciudad} onChange={handleNuevoTransportistaChange} className="input" /></div>
                                            <div className="input-group"><input type="text" name="pais" placeholder="País" value={nuevoTransportista.pais} onChange={handleNuevoTransportistaChange} className="input" /></div>
                                            <div className="input-group"><input type="text" name="telefono" placeholder="Número de teléfono" value={nuevoTransportista.telefono} onChange={handleNuevoTransportistaChange} className="input" /></div>
                                            <div className="input-group"><input type="email" name="correoElectronico" placeholder="Correo electrónico" value={nuevoTransportista.correoElectronico} onChange={handleNuevoTransportistaChange} className="input" /></div>
                                            <div className="input-group"><input type="text" name="nombreVendedor" placeholder="Nombre del vendedor" value={nuevoTransportista.nombreVendedor} onChange={handleNuevoTransportistaChange} className="input" /></div>
                                        </>
                                    )}
                                    <label className='data-label'>Fecha de despacho</label>
                                    <div className="input-group"><input type="text" inputMode="numeric" placeholder="dd/mm/aaaa" value={fechaDespacho} onChange={(e) => setFechaDespacho(formatearFechaInput(e.target.value))} className="input" /></div>
                                    <label className="data-label">Costo de envío</label>
                                    <div className="input-group number" style={{ maxWidth: '160px' }}><input type="text" placeholder="Costo de envío" value={costoEnvioEstimado} onChange={(e) => setCostoEnvioEstimado(formatNumberWithDots(e.target.value))} className="input" /><span className='unit'>$</span></div>
                                    <label className="data-label">Bultos totales</label>
                                    <div className="input-group number" style={{ maxWidth: '160px' }}><input type="text" inputMode="numeric" placeholder="Cantidad de bultos" value={bultosTotales} onChange={(e) => setBultosTotales(e.target.value.replace(/\D/g, ''))} className="input" /></div>
                                    <label className="data-label">Despachante</label>
                                    <div className="input-group"><input type="text" placeholder="Nombre del despachante" value={despachante} onChange={(e) => setDespachante(e.target.value)} className="input" /></div>
<div className="input-group">
    <label className='date-label'>Adjuntar etiqueta / guía</label>
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
        <button type="button" onClick={handleArchivoEnvioButtonClick} className="pdf-button">
            <ClipIcon style={{ height: '15px' }} /> Seleccionar archivo
        </button>
        <input type="file" accept="application/pdf,image/*" onChange={handleArchivoEnvioFileChange} ref={archivoEnvioInputRef} style={{ display: 'none' }} />
        
        {archivoEnvio && (
            <p style={{ margin: 0, cursor: 'default', fontSize: '13px', fontFamily: 'Effra', display: 'flex', alignItems: 'center', gap: '8px', color: '#2c2c2c' }}>
                {archivoEnvio.name}<span className='no-pdf' onClick={() => setArchivoEnvio(null)}>×</span>
            </p>
        )}

{isEditing && !archivoEnvio && archivoEnvioUrl && (
    <a 
        href={archivoEnvioUrl} 
        target="_blank" 
        rel="noopener noreferrer"
        style={{ 
            fontSize: '13px', 
            fontFamily: 'Effra', 
            color: '#6b7280', 
            textDecoration: 'none', 
            fontWeight: 500,
            transition: 'color 0.2s ease',
            cursor: 'pointer'
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = '#111827'}
        onMouseLeave={(e) => e.currentTarget.style.color = '#6b7280'}
    >
        Ver archivo actual
    </a>
)}
    </div>
</div>
                                </>
                            )}
                            <div className="button-container" style={{ marginTop: '50px' }} >
                                <hr style={{ border: "0", borderTop: "1px solid #eaeef5", margin: "0px 0 0px" }} />
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: '15px', width: '100%' }}>
                                    <button
                                        type="submit"
                                        className={`button ${saveState === 'saved' ? 'success' : ''}`}
                                        disabled={(estado === 'Entregado' && (faltanCajasX6 || faltanSeparadores)) || isLoading}
                                        title={estado !== 'Entregado' ? undefined : faltanCajasX6 ? `No hay suficiente stock de '${cajaElegida?.nombre || cajaId}': hacen falta ${cajasX6Faltantes} y quedan ${cajaX6Disponible}.` : faltanSeparadores ? `No hay suficiente stock de '${separadorElegido?.nombre || separadorId}': hacen falta ${separadoresFaltantes} y quedan ${separadorDisponible}.` : undefined}
                                        style={{ margin: 0, flex: '0 0 calc(50% - 7.5px)' }}
                                    >
                                        <span className="button-text">{saveState === 'saved' ? 'Guardado' : isEditing ? 'Guardar cambios' : 'Vender'}</span>
                                        {isLoading && <span className="progress-bar" style={{ width: `${progress}%` }}></span>}
                                    </button>
                                    {requiereEnvio && (() => {
                                        const motivoGuia = motivoNoImprimirGuiaForm();
                                        const deshabilitadoGuia = !!motivoGuia || imprimiendoGuiaForm;
                                        return (
                                            <button type="button" className="button" onClick={() => { if (!deshabilitadoGuia) handleImprimirGuiaForm(); }} disabled={deshabilitadoGuia} title={motivoGuia || "Imprimir guía de envío"} style={{ margin: 0, flex: '0 0 calc(50% - 7.5px)', backgroundColor: '#39b54a', opacity: deshabilitadoGuia ? 0.5 : 1 }}>
                                                <span className="button-text">Imprimir guía</span>
                                            </button>
                                        );
                                    })()}
                                </div>
                                {saveState === 'error' && errorMsg && <p className="form-error-message">{errorMsg}</p>}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {mostrarFactura && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '0%', height: '0%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                    <div style={{ position: 'relative', width: '210mm', height: '297mm', overflowY: 'auto' }}>
                        {[
                            { ref: facturaOriginalRef, copia: 'ORIGINAL' },
                            { ref: facturaDuplicadoRef, copia: 'DUPLICADO' },
                            { ref: facturaTriplicadoRef, copia: 'TRIPLICADO' },
                        ].map(({ ref: facturaRef, copia }) => (
<Factura
    key={copia}
    ref={facturaRef}
    copia={copia}
    datosCliente={datosClienteParaImprimir}
    productosVendidos={obtenerProductosProcesados()}
    tipoFactura={tipoFactura}
    totalNeto={calcularTotalNeto()}
    iva21={tipoFactura !== 'R' ? iva21 : 0}
    iva10_5={tipoFactura !== 'R' ? iva10_5 : 0}
    ivaTotal={tipoFactura !== 'R' ? ivaTotal : 0}
    totalFinal={totalFinal}
    numeroComprobante={numeroFactura}
    modalidadPago={modalidadPago}
    datosCheque={datosCheque}
    tipoDivisa={tipoDivisa}
    fechaVenta={isEditing ? formData.fechaVenta : new Date()}
/>
                        ))}
                        {!tieneSeña() && (
                            <Remito
                                ref={remitoRef}
                                datosCliente={datosClienteParaImprimir}
                                productosVendidos={obtenerProductosProcesados()}
                                tipoFactura={tipoFactura}
                                totalNeto={calcularTotalNeto()}
                                iva21={iva21}
                                iva10_5={iva10_5}
                                ivaTotal={ivaTotal}
                                totalFinal={totalFinal}
                                numeroComprobante={numeroFactura}
                                modalidadPago={modalidadPago}
                                tipoDivisa={tipoDivisa}
                            />
                        )}
                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button onClick={() => setMostrarFactura(false)}>Cerrar</button>
                        </div>
                    </div>
                </div>
            )}
            {imprimiendoGuiaForm && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: 0, height: 0, overflow: 'hidden' }}>
                    {Array.from({ length: Number(bultosTotales) || 1 }).map((_, i) => (
                        <GuiaEnvio key={i} ref={(el) => { guiaFormRefs.current[i] = el; }} cliente={selectedCliente || formData} direccionEntrega={direccionEntregaVenta} empresaTransporte={empresaTransporteActual()} observaciones={direccionEntregaVenta.observaciones} despachadoPor={despachante} cantidadBultos={Number(bultosTotales) || 1} bultoNumero={i + 1} />
                    ))}
                </div>
            )}
        </div>
    );
};

// Las rutas /nueva-venta y /ventas/editar/:id renderizan el mismo elemento en la
// misma posicion del arbol, asi que React reusa la instancia del formulario y el
// estado de la venta anterior sobrevive al cambio de ruta (los campos aparecen
// autocompletados con la venta que se estaba editando). La key fuerza el remonte
// en cada cambio de venta y al pasar de editar a nueva.
const VentasFormRoute = () => {
    const { id } = useParams();
    return <VentasForm key={id || 'nueva'} />;
};

export default VentasFormRoute;